var _effectorFileName = "/src/pages/for-companies/index.page.tsx";
import { GetServerSideProps } from 'next';
import { allSettled, fork, serialize } from 'effector';
import { forCompaniesPage, ForCompaniesPage } from '@/page-content/for-companies';
import { EFFECTOR_STATE_KEY } from '@/shared/lib/effector';
import { getPageContext } from '@/shared/lib/effector/page';
export const getServerSideProps: GetServerSideProps = async ctx => {
  const scope = fork();
  await allSettled(forCompaniesPage.open, {
    scope,
    params: getPageContext(ctx)
  });
  return {
    props: {
      [EFFECTOR_STATE_KEY]: serialize(scope)
    }
  };
};
export default ForCompaniesPage;